export default {
	REPORT_SUCCESS_0: 0,//wupcode>=0 
	REPORT_SUCCESS_1: 1, //通道错误 
	REPORT_SUCCESS_2: 2, //wupcode<0 

	SIGNAL_ERROR_LOCAL_TIMEOUT: -1,//本地任务超时 
	SIGNAL_ERROR_LOCAL_ERROR: -3, //本地开始任务失败
	SIGNAL_ERROR_NO_INIT: -10,  //信令未初始化时进行请求
	SIGNAL_ERROR_FIRST_PACKAGE: -500,  //首包异常或者返回值解析错误
    SIGNAL_ERROR_WS_SEND_ERROR: -10092,  //socket发送异常
    SIGNAL_ERROR_READ_ERROR: -10504,  //解析流消息失败（解包错误）

	SIGNAL_ERROR_WRITE_ERROR: -20001,  //封包错误
	SIGNAL_ERROR_NO_REGISTER: -20002,  //未注册的接口

	SIGNAL_HTTP_REQUEST_ERROR: -20003 //http请求错误(包括dns错误)


}